import type { JSX } from 'react';

import { CurrencyInput, CurrencyInputProps } from '../MCurrencyInput/CurrencyInput';
import { MFormItem } from '../MFormItem/MFormItem';

export interface MFormCurrencyInputProps extends CurrencyInputProps {
  label: string;
  tooltip?: {
    type: 'modal' | 'popover';
    title: string;
    content: string | JSX.Element;
  };
  size?: 'small' | 'middle' | 'large';
  weight?: 'light' | 'medium';
  testId?: string;
}

export const MFormCurrencyInput = ({
  label,
  placeholder,
  value,
  defaultValue,
  error,
  onChange,
  disabled,
  weight,
  tooltip,
  className,
  name,
  autoComplete,
  testId,
}: MFormCurrencyInputProps) => {
  return (
    <MFormItem label={label} tooltip={tooltip} weight={weight} testId={testId}>
      <CurrencyInput
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        placeholder={placeholder}
        error={error}
        disabled={disabled}
        name={name}
        autoComplete={autoComplete}
        className={className}
        testId={testId}
      />
    </MFormItem>
  );
};
